import { Sprite, Texture } from 'pixi.js';
import ActionButton from './ActionButton';
import { EVENTS } from '../lib/constants';

class MouseOverSprite extends ActionButton {
	constructor(obj) {
		super(obj);
		this.interactive = true;
		this.name = obj.name;
		this.img = Sprite.from(Texture.from(obj.img));
		this.addChild(this.img);
		this.imgHover = Sprite.from(Texture.from(obj.imgHover));
		this.addChild(this.imgHover);
		this.imgHover.alpha = 0;
		this.enabled = true;
		window.addEventListener(EVENTS.ERROR_PAGE, this, false);
		if (window.isMobile || window.isTablet) {
			this.on('pointerover', this.pointerOver.bind(this));
			this.on('pointerout', this.pointerOut.bind(this));
		} else {
			this.on('mouseover', this.pointerOver.bind(this));
			this.on('mouseout', this.pointerOut.bind(this));
		}
	}

	toggleEnabled(b) {
		this.enabled = b;
	}

	handleEvent(evt) {
		//TODO checn error
		if (window.isMobile || window.isTablet) {
			this.off('pointerover');
			this.off('pointerout');
		} else {
			this.off('mouseover');
			this.off('mouseout');
		}
	}
	pointerOut(e) {
		if (this.enabled) {
			this.img.alpha = 1;
			this.imgHover.alpha = 0;
			if (this.config) {
				if (!this.config.mobile) {
					for (let i = 0; i < this.config.default.length; i++) {
						this.child_passive = this.getChildByName(
							this.config.default[i],
							true
						);
						this.child_passive.alpha = 1;
					}
					for (let i = 0; i < this.config.hover.length; i++) {
						this.child_active = this.getChildByName(this.config.hover[i], true);
						this.child_active.alpha = 0;
					}
				}
			}
		}
	}

	pointerOver(e) {
		if (this.enabled) {
			this.img.alpha = 0;
			this.imgHover.alpha = 1;
			if (this.config) {
				if (!this.config.mobile) {
					for (let i = 0; i < this.config.default.length; i++) {
						this.child_passive = this.getChildByName(
							this.config.default[i],
							true
						);
						this.child_passive.alpha = 0;
					}
					for (let i = 0; i < this.config.hover.length; i++) {
						this.child_active = this.getChildByName(this.config.hover[i], true);
						this.child_active.alpha = 1;
					}
				}
			}
		}
	}
}

export default MouseOverSprite;
